import styled from 'styled-components';
import { StyledInput } from '../Input/Input.styles';


export const StyledTextArea = styled(StyledInput.TextArea)`
  background: transparent;
  border-color: ${({ theme }) => theme.currentModeConfig.inputBorderColor};
`;
